<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：电表充值
    -->
	<div class="meterList">
		<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="seach">
			<el-form-item label="表号">
				<el-input v-model="select.code" placeholder="表号" :maxlength="12" style="width:150px"></el-input>
			</el-form-item>
			<el-form-item label="表类型">
				<el-select v-model="select.type" placeholder="请选择" style="width: 200px;">
					<el-option v-for="item in types" :key="item.id" :label="item.label" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="业主类型">
				<el-select v-model="select.nature" placeholder="请选择" style="width: 110px;">
					<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="业主姓名">
				<el-input v-model="select.owner_name" placeholder="业主姓名" style="width: 150px;"></el-input>
			</el-form-item>
			<!--<el-form-item label="业主电话">
				<el-input v-model="select.owner_phone" placeholder="业主电话" :maxlength="11" style="width: 120px;"></el-input>
			</el-form-item>-->
			<el-form-item label="地址">
				<el-input v-model="select.address" placeholder="地址"></el-input>
			</el-form-item>
			<!--<el-form-item label="单元">
				<el-input v-model="select.unitnum" placeholder="单元"></el-input>
			</el-form-item>
			<el-form-item label="门牌号">
				<el-input v-model="select.doornum" placeholder="门牌号" style="width: 100px;"></el-input>
			</el-form-item>-->
			<el-form-item>
				<el-button type="primary" @click="seach">查询</el-button>
				<el-button type="primary" @click="resetting">重置</el-button>
			</el-form-item>
		</el-form>
		<!--表单列表-->
		<el-table :data="meterList" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;margin-top: 10px;" v-on:sort-change="sortChange">
			<el-table-column prop="code" label="表号" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="tra_type" label="表类型" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="nature" label="业主类型"  align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="owner_name" label="业主姓名"  align="center" sortable="custom">
			</el-table-column>
			<!--<el-table-column prop="owner_phone" label="业主电话" align="center" sortable="custom">
			</el-table-column>-->
			<el-table-column prop="address1" label="地址" width="412" align="center" sortable="custom">
			</el-table-column>
			<!--<el-table-column prop="buildnum" label="栋" width="220" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="unitnum" label="单元" width="220" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="doornum" label="门牌号" width="150" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="community_name" label="小区名称" width="220" align="center" sortable="custom">
			</el-table-column>-->
			<el-table-column prop="sumbit" align="center" label="操作">
				<template scope="scope">
					<router-link :to="{name:'OrderCreate', params: {type: meterList[scope.$index].type, unit: (meterList[scope.$index].unit_price == '' ? '-1' : meterList[scope.$index].unit_price), metercode: scope.row.code}}">
						<el-button type="primary" size="mini">充值</el-button>
					</router-link>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
		</el-pagination>
	</div>
</template>
<script>
	import {mapState } from 'vuex'
	export default {
		name: 'meter-list',
		data() {
			return {
				types: [
					{
						id: '7',
						label: '水表'
					},
					{
						id: '10',
						label: '多功能单相'
					},
					{
						id: '11',
						label: '多功能三相'
					}
				],
				select: {
					code: '',
					owner_name: '',
					owner_phone: '',
					//buildnum: '',
					//unitnum: '',
					//doornum: '',
					address:'',
					nature: '',
					type:'',
				},
				meterList: [],
				total: 0,
				pageSize: 15,
				natures: [/*{
						num: '0',
						value: '居民',
					},
					{
						num: '1',
						value: '自营'
					},
					{
						num: "2",
						value: '联营'
					},
					{
						num: '3',
						value: '出租'
					},
					{
						num:'4',
						value:'物业动力'
					},
					{
						num:'5',
						value:'居民配套'
					},
					{
						num: '9',
						value: '备用'
					},
*/
				],
				prop:'',
				order:'',
			} //return的结尾
		},
		created:function(){
			this.searchNature()
			this.seach()
		},
		methods: {
			searchNature(){
				this.$jssdk.member.getNature({
					
				},(res) =>{
					this.natures = res
					console.log(res)
				})
			},
			sortChange(item) {
				var order = item.order
				var prop = item.prop
				this.prop = prop
				this.order = order
				const code = this.select.code
				const ownerName = this.select.owner_name
				const ownerPhone = this.select.owner_phone
				//const buildnum = this.select.buildnum
				//const unitnum = this.select.unitnum
				//const doornum = this.select.doornum
				var address= this.select.address
				const nature = this.select.nature
				const typen = this.select.type
				this.$jssdk.meter.list({
					code: code,
					type: typen,
					owner_name: ownerName,
					owner_phone: ownerPhone,
					//buildnum: buildnum,
					//unitnum: unitnum,
					//doornum: doornum,
					address:address,
					nature: nature,
					sort_by: prop,
					sort_to: order
				}, (data) => {
					this.meterList = data.meterList.data
					this.total = data.meterList.total
				}, (err) => {
					this.$message.warning(err.msg);
				})
			},
			seach() {
				const code = this.select.code
				const ownerName = this.select.owner_name
				const ownerPhone = this.select.owner_phone
				const buildnum = this.select.buildnum
				//const unitnum = this.select.unitnum
				//const doornum = this.select.doornum
				const nature = this.select.nature
				var address = this.select.address
				const typen = this.select.type
				this.$jssdk.meter.list({
					code: code,
					owner_name: ownerName,
					owner_phone: ownerPhone,
					//buildnum: buildnum,
					//unitnum: unitnum,
					//doornum: doornum,
					address:address,
					nature: nature,
					type: typen,
				}, (data) => {
					this.meterList = data.meterList.data
					this.total = data.meterList.total
				}, (err) => {
					this.$message.warning(err.msg);
				})
			},

			resetting() {
				this.select.code = ''
				this.select.owner_name = ''
				this.select.owner_phone = ''
				this.select.buildnum = ''
				this.select.unitnum = ''
				this.select.doornum = ''
				this.select.nature = ''
				this.select.address = ''
				this.select.type = ''
			},
			handleSizeChange(val) {},
			handleCurrentChange(val) {
				const code = this.select.code
				const ownerName = this.select.owner_name
				const ownerPhone = this.select.owner_phone
				//const buildnum = this.select.buildnum
				//const unitnum = this.select.unitnum
				//const doornum = this.select.doornum
				var address = this.select.address
				const nature = this.select.nature
				this.$jssdk.meter.list({
					code: code,
					owner_name: ownerName,
					owner_phone: ownerPhone,
					//buildnum: buildnum,
					//unitnum: unitnum,
					//doornum: doornum,
					address:address,
					page: val,
					nature: nature,
					sort_by: this.prop,
					sort_to: this.order
				}, (data) => {
					this.meterList = data.meterList.data
				}, (err) => {
					this.$message.warning(err.msg);
				})
			}
		},
		computed:{
			naturesData(){
				return this.natures = this.nature
			},
			...mapState(['nature'])
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.meterList {
		background-color: white;
		padding-top: 20px;
	}
</style>


// WEBPACK FOOTER //
// MeterList.vue?0aa2f33c